import { UpsellBase } from '../upsell/upsell-base';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension'
//import { LoadingController, NavParams, ToastController } from 'ionic-angular';
import { LoadingController } from 'src/app/components/ionic-replacements/LoadingController';
import { NavParams } from 'src/app/components/ionic-replacements/NavParams';
import { ToastController } from 'src/app/components/ionic-replacements/ToastController';

import { TouchcrApiOrderProvider } from 'src/app/providers/touchcr-api-order/touchcr-api-order';
import { TouchcrApiGeneralProvider } from 'src/app/providers/touchcr-api-general/touchcr-api-general';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { OrderDetailsProvider } from 'src/app/providers/order-details/order-details';
import { PaypalPaymentProvider } from 'src/app/providers/paypal/paypal';
import { Inject, Injectable, NgZone, OnDestroy } from '@angular/core';
import { TouchcrApiShippingProvider } from 'src/app/providers/TouchcrApiShippingProvider';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { CalculateProvider } from 'src/app/providers/calculate/calculate';
import { UrlsProvider } from 'src/app/providers/urls';
import { StateProvider } from 'src/app/providers/state';
import { TouchcrApiOrderformProvider } from 'src/app/providers/touchcr-api-orderform/touchcr-api-orderform';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { GeneralProvider } from 'src/app/providers/general';
import { SpinnerProvider } from 'src/app/providers/spinner/spinner';

const BRAND = (window as any)['process_env'].BRAND;

@Injectable({ providedIn: 'root' })
export class UpsellFunnelSettingsBase extends UpsellBase implements OnDestroy {
  
  /** Data object used to tokenize a Braintree payment */
  braintreeTokenizePaymentData: any;

  /** PayPal payment ID for the transaction */
  paypalpaymentId: string;

  /** Client token received from Braintree for authentication */
  braintreeClientToken: any;

  /** Whether to display the PayPal payment button */
  showPayPalPayButton: boolean;

  /** Default country code for Braintree payments */
  braintreeDefaultCountry: string;

  /** Language translation ID for Braintree UI */
  braintreeLanguageTranslation: number;

  /** Whether Braintree payment integration is enabled */
  braintreeEnabled: boolean;

  /** Whether this is a subscription payment */
  isSubscription: boolean;

  /** Whether Braintree A/B testing is enabled */
  braintreeSplitTesting: boolean;

  /** Instance of the Braintree client */
  braintreeInstance: any;

  /** Whether Braintree is currently loading */
  isBraintreeLoading: boolean;

  /** Instance of PayPal checkout via Braintree */
  paypalCheckoutInstance: any;

  /** Whether to hide the PayPal button */
  hidePaypalButton: boolean;

  /** Tokenized payment data from Braintree PayPal flow */
  braintreePayPalTokenizedPayment: any;

  /** Whether to use updated Braintree UI styles */
  useNewBraintreeStyles: boolean;

  /** Customer email from Braintree PayPal flow */
  braintreePayPalEmail: string;

  /** Whether Braintree Drop-in UI is valid */
  braintreeDropinValid: boolean;

  /** Whether to hide PayPal button in Braintree flow */
  braintreeHidePayPalButton: boolean;

  /** Whether CB2 payment option is selected */
  isSelectedCB2: boolean;

  /** Whether using common checkout terms & conditions */
  isCheckoutCommonTC: boolean;

  /** Callback to handle CB2 state changes */
  changeStateCB2: () => void;

  /** Payment method nonce from Braintree */
  braintreeNonce: string;

  /** DOM element for payment overlay */
  overlayDiv: any;

  override braintreeCurrencyConversion: number = 1; // TOUC-14710
  officialCurrency: string = 'USD';
  override currencySymbol: string = "$"; // TOUC-14710
  currency: string = 'USD'; // TOUC-14710
  
  constructor(
    public override navCtrl: NavControllerExt,
    public override navParams: NavParams,
    public override tcrApi: TouchcrApiGeneralProvider,
    public override tcrApiOrder: TouchcrApiOrderProvider,
    public override loadingCtrl: LoadingController,
    public override eventStreamer: EventStreamerProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentProvider,
    public override toastCtrl: ToastController,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override stateProvider: StateProvider,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public funnelProvider: FunnelSettingsProvider,
    public override generalProvider: GeneralProvider,
    public override spinner: SpinnerProvider,
  ) {
    super(
      navCtrl,
      navParams,
      tcrApi,
      tcrApiOrder,
      loadingCtrl,
      eventStreamer,
      orderDetails,
      paypalPayment,
      toastCtrl,
      ngZone,
     
      shippingProvider,
      tcrApiRemoteServices,
      calculateHelper,
      urlsHelper,
      stateProvider,
      tcrApiOrderform,
      generalProvider,
      spinner,
    );
  }
  ngOnDestroy(): void {
    this.spinner.disable();
  }

  similarity(s1:any, s2:any) {
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
      longer = s2;
      shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength === 0) {
      return 1.0;
    }
    return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
  }


  editDistance(s1:any, s2:any) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array();
    for (var i = 0; i <= s1.length; i++) {
      var lastValue = i;
      for (var j = 0; j <= s2.length; j++) {
        if (i == 0)
          costs[j] = j;
        else {
          if (j > 0) {
            var newValue = costs[j - 1];
            if (s1.charAt(i - 1) != s2.charAt(j - 1))
              newValue = Math.min(Math.min(newValue, lastValue),
                costs[j]) + 1;
            costs[j - 1] = lastValue;
            lastValue = newValue;
          }
        }
      }
      if (i > 0)
        costs[s2.length] = lastValue;
    }
    return costs[s2.length];
  }

  getAlternativeOffer(brokenactual:any) {
    let matchto = brokenactual.substring(0,3);

    console.log("getAlternativeOffer: " + brokenactual);
    console.log("matchto: " + matchto);
    let foundp = false;
    let winner:any = '';
    let winnerPerc =0;

    if (this.navCtrl.getConfig()) {

      for (let prod = 0; prod < this.navCtrl.getConfig().length; prod++) {
        
        if (this.navCtrl.getConfig()[prod].path?.startsWith(matchto)) {
          let perc = Math.round(this.similarity(brokenactual, this.navCtrl.getConfig()[prod].path) * 10000) / 100;
          if(perc > winnerPerc) {
            winnerPerc = perc;
            winner = this.navCtrl.getConfig()[prod].path;
          }
          foundp = true;
          console.log("found p: " + brokenactual  + " and " + this.navCtrl.getConfig()[prod].path + " are similar " + perc + "%");
        }
      }
    }
    if (!foundp) {
      return 'Gundry_Receipt_AP';
    }
    return winner;   
  }

  showNext(skip:any) {	
    this.dataForTax = this.getTaxRateForUpsells({	
      detailsInfo: this.orderDetailsInfo,	
      upsellIndex: this.upsellIndex,	
    });	
    this.tcrApiRemoteServices	
      .getTaxRateForUpsell(this.dataForTax, this.state)	
      .toPromise()	
      .then((taxRate:any) => {	
        this.taxRate = taxRate;	
        if (taxRate === 'error') {	
          this.isErrorTax = true;	
        }	
        this.calculateTransactionFee();	
      });	
    return;	
  }
  override async noThanks() {
    let stp = this.urlsHelper.getParameterFromUrl({url: document.location.search, parameter: 'step'})
    this.spinner.enable('Loading page <br> Please wait...');
    for (let index = 0; index < this.buttonList.length; index++){
      this.buttonList[index].isPlaceOrder = true;
    }
    const params: any = await this.funnelProvider.getNextPage(undefined, false, this.upsell.type);
    if (!params) {
      setTimeout(() => {
        this.spinner.disable();
      },1000);

      if( typeof (window as any)['funnelConfsForUUID'] == 'object') {
        // handle the configuration error
        let brokenfunnel = (window as any)['funnelConfsForUUID'];
        let brokenfunnel_firstUpsell = brokenfunnel.defaultFunnels[stp].variants[0].url;
        let alt = this.getAlternativeOffer(brokenfunnel_firstUpsell);
        if(alt) {
          console.log("redirecting to alternative offer: " + alt);
          //return this.navCtrl.setRootExt(alt, { name: alt},{currentStep: stp, nextStep: (stp+1) });
          //return this.navCtrl.setRootExt(alt, { name: alt});
          return this.navCtrl.setRootExt(alt, { name: alt, isUpsell: true }, { taken: false, alternate: true})
        }
      }

      return this.toastCtrl
        .create({
          message: `Page not found`,
          position: 'top',
          showCloseButton: true,
          cssClass: 'errorToast',
        })
    }
    setTimeout(() => {
      this.spinner.disable();
    }, 1000);
    const { component, orderForm, type } = params;
    if (type === 'Upsell' || type === 'DownSell') {
      await this.stateProvider.setUpsells([orderForm]);
    }
    this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: false})
      .then(() => {
        this.spinner.disable();
      })
      .catch((error) => {
        console.log('Error on noThanks()', error);
        this.spinner.disable();
      });
    return;
  }

  setBraintree(braintreeCurrencyConversion:any, currencySymbol:any) {
    this.braintreeCurrencyConversion = braintreeCurrencyConversion;
    this.currencySymbol = currencySymbol;
  }

  /**
   * Gets a payment nonce from Braintree PayPal Checkout
   * 
   * This method uses the PayPal Checkout instance to tokenize the payment data and get a nonce.
   * The nonce is then stored and used to upgrade the Braintree order.
   * 
   * @returns Promise that resolves when the nonce is obtained and order is upgraded
   */
  async braintreeGetNonce() {
    return this.paypalCheckoutInstance.tokenizePayment(this.braintreeTokenizePaymentData, (err:any, payload:any) => {
      console.log('[GH] braintree paypal tokenized payment', payload);
      // TOUC-14710 https://developer.paypal.com/braintree/docs/guides/payment-method-nonces
      this.braintreeNonce = payload.nonce;
      console.log('[GH] braintreeNonce ', this.braintreeNonce);
      this.upgradeBraintreeOrder(sessionStorage.getItem('deviceData'));
    });
  }

  /**
   * Shows a modal dialog containing a PayPal payment button
   * 
   * Creates and displays a modal overlay with a PayPal button for completing payment.
   * The modal includes:
   * - Semi-transparent dark background overlay
   * - Centered white modal box
   * - Title and description text
   * - PayPal button container
   * - X button in upper right corner to close the modal
   * 
   * Styles are applied inline to position and style the modal elements.
   * A style tag is added to customize the PayPal button border radius.
   * The modal can be closed by clicking the X button which removes
   * the overlay and disables the loading spinner.
   */
  showPayPalButtonDialog() {
    // Create overlay div
    this.overlayDiv = document.createElement('div');
    this.overlayDiv.style.position = 'fixed';
    this.overlayDiv.style.top = '0';
    this.overlayDiv.style.left = '0';
    this.overlayDiv.style.width = '100%';
    this.overlayDiv.style.height = '100%';
    this.overlayDiv.style.backgroundColor = 'rgba(0,0,0,0.7)';
    this.overlayDiv.style.zIndex = '9999';

    // Create payment modal
    const modalDiv = document.createElement('div');
    modalDiv.className = 'paypal-modal';
    modalDiv.style.fontFamily = 'Arial, sans-serif';
    modalDiv.style.position = 'fixed';
    modalDiv.style.top = '50%';
    modalDiv.style.left = '50%';
    modalDiv.style.transform = 'translate(-50%, -50%)';
    modalDiv.style.backgroundColor = 'white';
    modalDiv.style.padding = '20px';
    modalDiv.style.borderRadius = '5px';
    modalDiv.style.maxWidth = '400px';
    modalDiv.style.width = '90%';
    modalDiv.style.height = '170px';
    modalDiv.style.position = 'relative';

    const style = document.createElement('style');
    style.textContent = `
      .paypal-button {
        border-radius: 25px !important;
      }
    `;
    document.head.appendChild(style);

    // Create X button in upper right corner
    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '10px';
    closeButton.style.right = '15px';
    closeButton.style.background = 'none';
    closeButton.style.border = 'none';
    closeButton.style.fontSize = '24px';
    closeButton.style.fontWeight = 'bold';
    closeButton.style.cursor = 'pointer';
    closeButton.style.color = '#666';
    closeButton.style.lineHeight = '1';
    closeButton.style.padding = '0';
    closeButton.style.width = '30px';
    closeButton.style.height = '30px';
    closeButton.style.display = 'flex';
    closeButton.style.alignItems = 'center';
    closeButton.style.justifyContent = 'center';

    // Add hover effect
    closeButton.addEventListener('mouseenter', () => {
      closeButton.style.color = '#000';
    });
    closeButton.addEventListener('mouseleave', () => {
      closeButton.style.color = '#666';
    });

    // Add click event listener to remove overlay
    closeButton.addEventListener('click', () => {
      if (document.body.contains(this.overlayDiv)) {
        document.body.removeChild(this.overlayDiv);
      }
      this.spinner.disable();
    });

    modalDiv.innerHTML = `
      <div style="position: relative">
        <h3 style="margin-top:0; padding-right: 30px;">Payment Required</h3>
        <p>Please complete your payment with PayPal to continue with your order.</p>
        <div style="height: 35px; background: #ffc439; width: 100%; border-radius: 18px; display: flex; align-items: center; justify-content: center; opacity: 0.6;">
          <img style="display:block; margin: auto; height: 18px;" class="paypalBtnPlaceholder" src="/assets/img/paypal-bare.png" alt="PayPal" />
        </div>
        <div id="paypal-button" style="position: absolute; bottom: 0; width: 100%; display: flex;"></div>
      </div>
    `;

    // Append the close button to the modal
    modalDiv.appendChild(closeButton);
    this.overlayDiv.appendChild(modalDiv);
    document.body.appendChild(this.overlayDiv);
  }

  /**
   * Handles the display state of the Braintree loading indicator
   * 
   * This method sets a timeout to disable the loading indicator after 333ms.
   * It is used to ensure the loading state is properly managed during Braintree interactions.
   */
  braintreeDisplayHandler() {
    setTimeout(() => {
      this.isBraintreeLoading = false;
    }, 333);
  }

  /**
   * Sets up the Braintree client for PayPal payment processing
   * 
   * This method initializes the Braintree client and PayPal Checkout instance.
   * It also handles the JWT callback for Braintree payment processing.
   */
  async setupBraintreeClient() {
    // TOUC-14710
    if ( this.braintreeCurrencyConversion) {
      this.showPayPalPayButton = false; // use paypal from braintree
      
      (window as any)['jwtCallback'] = (data:any) => {
        console.log('[GH] jwt upsell callback ', data);
        this.braintreeClientToken = data['jwt'];
        if (this.braintreeClientToken && this.braintreeClientToken.trim().length > 0) {
          this.showPayPalPayButton = false; // use paypal from braintree
          sessionStorage.setItem('braintreeDefaultCountry', this.braintreeDefaultCountry);
          console.log('[GH] this.currency', this.currency);
          console.log('[GH] this.currencySymbol', this.currencySymbol);
          sessionStorage.setItem('currency', this.currency);
          sessionStorage.setItem('currencySymbol', this.currencySymbol);
          this.braintreeEnabled = true;
          this.braintreepaypalSetup();
          this.showPayPalPayButton = false;

        } else {
          this.showPayPalPayButton = true; // use paypal legacy
        }
      }
      let jwtscript = document.createElement('script');
      jwtscript.src = '/checkout-jwt/?callback=jwtCallback';
      jwtscript.type = 'application/javascript';
      document.body.appendChild(jwtscript);
    }
  }

  /**
   * Tears down the Braintree client and resets all Braintree-related properties
   * 
   * This method resets all Braintree-related properties to their initial values.
   * It is used to clean up the Braintree client when the upsell is no longer needed.
   */
  tearDownBraintree() {
    this.braintreeCurrencyConversion = 1;
    this.braintreeSplitTesting = false;
    this.currency = 'USD';
    this.currencySymbol = '$'; // TODO get from constants
    this.showPayPalPayButton = true; 
    this.braintreeClientToken = null;
    this.braintreeInstance = null;
    this.braintreeEnabled = false;
    this.ngZone.run(() => {
      this.braintreeDisplayHandler();
    });
    sessionStorage.removeItem('currencySymbol');
    sessionStorage.removeItem('currency');
  }

  /**
   * Sets up the Braintree PayPal Checkout instance
   * 
   * This method creates a Braintree client and initializes the PayPal Checkout instance.
   * It also handles the creation of the PayPal Checkout component.
   */
  braintreepaypalSetup() {
    // if ((window as any)['process_env']['BRAINTREE_PAYPAL_ENABLED'] === 'true') {
    // Create a client.
    (window as any)['braintree'].client.create({
      authorization: this.braintreeClientToken,
    }, (clientErr: any, clientInstance: any) => {
      if (clientErr) {
        this.braintreeDisplayHandler();
        console.error('Error creating client:', clientErr);
        return;
      }
      // Create a PayPal Checkout component.
      (window as any)['braintree'].paypalCheckout.create({
        client: clientInstance
      }, (paypalCheckoutErr: any, paypalCheckoutInstance: any) => {
        this.paypalCheckoutInstance = paypalCheckoutInstance;
        let paypalCheckoutInstancePayload = {
          commit: true, // Per Braintree, this makes the Blue PayPal button show 'Continue'
          vault: true,
          currency: this.officialCurrency,
          intent: 'capture'
        };
        if ((window as any)['process_env']['BRAINTREE_AUTOCOMPLETE_CHECKOUT'] == 'true' || document.location.search.indexOf('braintreeautocomplete=true') > -1) {
          paypalCheckoutInstancePayload['commit'] = true;
        }
        paypalCheckoutInstance.loadPayPalSDK(paypalCheckoutInstancePayload, () => {
          console.log('[GH] braintree paypal sdk loaded');
          if (!this.hidePaypalButton) {
            this.payPalLoader();
          }
          this.braintreeDisplayHandler();
        });
      });
    });
    // }

  }


  /**
   * Handles the shipping address change in the Braintree PayPal Checkout
   * 
   * This method validates the shipping address and returns a boolean indicating
   * whether the address is valid. It also sets the PayPal payment ID if available.
   * 
   * @param data - The shipping address data
   * @param actions - The actions object from Braintree
   * @returns Promise that resolves when the shipping address is validated
   */
  async actionHandler(data:any, actions:any) {
    console.log('[GH] braintree paypal shipping change', data);
    if(typeof  data.paymentID == 'string' ) this.paypalpaymentId = data.paymentID;
    console.log('[GH] braintree paypal shipping change actions', actions);
    // initial offer price loaded here and updated on recalculations
    console.log('[GH] braintree paypal sdk loaded with funnel.offerPrice',this.upsell.offerPrice);
    console.log('[GH] braintree paypal sdk loaded with braintreeCurrencyConversion', this.braintreeCurrencyConversion);

    if (typeof data.shipping_address == 'object') {
      let validCountry = false;
      for (const key in this.countries) {
        //console.log('[GH] checking country ', key);
        if (this.countries.hasOwnProperty(key)) {
          //console.log('[GH] hasownproperty country ', key);
          if ((this.countries as any)[key].value == data.shipping_address.country_code) {
            //console.log('[GH] valid country ', (this.countries as any)[key].value);
            validCountry = true;
          }
        }
      }
      if(!validCountry) {
        console.log('[GH] invalid country ', data.shipping_address.country_code);
        return false;
      }
    } 

    return true;
  }

  /**
   * Tokenizes the payment data for Braintree PayPal Checkout
   * 
   * This method tokenizes the payment data using the PayPal Checkout instance.
   * It also handles the tokenization process and updates the Braintree payment details.
   */
  braintreeTokenizePayment() {
    this.spinner.enable('Please Wait...');
    return this.paypalCheckoutInstance.tokenizePayment(this.braintreeTokenizePaymentData, (err:any, payload:any) => {
      console.log('[GH] braintree paypal tokenized payment', payload);
      this.braintreePayPalEmail = payload.details.email;
      this.braintreeDropinValid = true;
      this.braintreePayPalTokenizedPayment = payload;
      try {
        if ( (window as any)['process_env']['BRAINTREE_AUTOCOMPLETE_CHECKOUT'] !== 'true' && document.location.search.indexOf('braintreeautocomplete=true') == -1) {
          this.braintreeHidePayPalButton = true;
          if((this.isSelectedCB2 && !this.isCheckoutCommonTC) || (!this.isSelectedCB2 && this.isCheckoutCommonTC)) this.changeStateCB2();
          //this.braintreeToast = this.toastCtrl.create({ message: 'Please review your order and click "Submit Order" below.', position: 'top', showCloseButton: true, cssClass: 'successToast' });
          this.spinner.disable();

        } 
      } catch (e) {
        console.log('[GH] error in braintree paypal approve', e);
      } 
    });
  }

  /**
   * Determines if vaulting is enabled for the current upsell
   * 
   * This method checks the session storage for the braintreeUpsellVaulting and braintreeDownsellVaulting flags.
   * It returns true if either flag is set to 'true' and the upsell type is 'upsell'.
   * 
   * @returns boolean - true if vaulting is enabled, false otherwise
   */
  braintreeVaulting() {
    if(sessionStorage.getItem('braintreeUpsellVaulting') === 'true') {
      return true;
    }
    if(sessionStorage.getItem('braintreeDownsellVaulting') === 'true' && this.upsell.type === 'Downsell') {
      return true;
    }
    return false;
  }


  /**
   * Creates and loads the PayPal button for Braintree PayPal Checkout
   * 
   * This method creates a PayPal button using the PayPal SDK.
   * It also handles the styling and configuration of the PayPal button.
   */
  payPalLoader() {
    let styles = {
      shape: 'pill',
      label: '',
      height: 35
    };
    if (this.useNewBraintreeStyles) {
      styles = {
        shape: 'pill',
        label: 'checkout',
        height: 40
      };
    }
    
    (window as any)['paypal'].Buttons({
      style: styles,
      fundingSource: (window as any)['paypal'].FUNDING.PAYPAL,
      createOrder: () => {
        // initial offer price loaded here and updated on recalculations
        console.log('[GH] braintree paypal sdk loaded with totalPrice',  +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2));
        console.log('[GH] braintree paypal sdk loaded with braintreeCurrencyConversion', this.braintreeCurrencyConversion);
        let amount = (( +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2)) * this.braintreeCurrencyConversion).toFixed(2);
        let subtotal = (1 * (this.upsell.offerPrice as any) * this.braintreeCurrencyConversion).toFixed(2);


        // https://www.paypal.com/ph/brc/article/psd2-payment-requirements-make-sure-you-are-ready 
        let estimate = null;
        let estimateAmt = '0';


        let paypalOptions:any = {
          commit: true,
          requestBillingAgreement: this.braintreeVaulting(),
          flow: 'checkout',
          amount: amount,
          currency: this.officialCurrency,
          intent: 'capture', // Must match the intent passed in with loadPayPalSDK
          enableShippingAddress: false,
          shippingAddressEditable: false,
          shippingAddressOverride: {
            recipientName: this.orderDetailsInfo.order.customerName,
            line1: this.orderDetailsInfo.order.shippingAddress,
            line2: this.orderDetailsInfo.order.additionalShippingAddress,
            city: this.orderDetailsInfo.order.shippingCity,
            countryCode: this.calculateHelper.getCountryISOCode(this.countries, this.orderDetailsInfo.order.shippingCountry) || 'US',
            postalCode: this.orderDetailsInfo.order.shippingZipPostal,
            state: this.orderDetailsInfo.order.shippingState,
            email: this.orderDetailsInfo.customerEmail
          },
          billingAddressOverride: {
            recipientName: this.orderDetailsInfo.order.customerName,
            line1: this.orderDetailsInfo.order.billingAddress,
            line2: this.orderDetailsInfo.order.additionalBillingAddress,
            city: this.orderDetailsInfo.order.billingCity,
            countryCode: this.calculateHelper.getCountryISOCode(this.countries, this.orderDetailsInfo.order.billingCountry) || 'US',
            postalCode: this.orderDetailsInfo.order.billingZipPostal,
            state: this.orderDetailsInfo.order.billingState,
            email: this.orderDetailsInfo.customerEmail
          }
        };
        if(this.state && this.state.taxData) {
          let lineItems = [
            {
              name: "SubTotal",
              quantity: "1",
              kind: "debit",
              description: (this.state && this.state.taxData && this.state.taxData.productDetails) ? (this.state.taxData.productDetails as any)[0]['productDescription'] : document.title,
              unitAmount: subtotal,
              totalAmount: subtotal
            }
          ];
          paypalOptions['lineItems'] = lineItems;
          let checksum = parseFloat(amount) - ( parseFloat(estimateAmt) + (parseFloat(subtotal) + parseFloat((this.dataForTax.totalTax * this.braintreeCurrencyConversion).toFixed(2).toString()) + parseFloat( (this.upsell.shippingCost * this.braintreeCurrencyConversion).toFixed(2).toString())) + parseFloat( (this.upsell.couponDiscount * this.braintreeCurrencyConversion).toFixed(2).toString()));          
          if(!checksum) {
            checksum = 0;
          }
          if (parseFloat(checksum.toFixed(2)) != 0) {
            let kind = 'credit';
            if (checksum > 0) kind = 'debit';
            let correction = {
              name: "Currency Conversion Rounding Correction",
              quantity: "1",
              kind: kind,
              description: 'Currency Conversion Rounding Correction',
              unitAmount: checksum.toFixed(2).replace('-', ''),  // TODO deal with our number always being negative and braintree not liking that
              totalAmount: checksum.toFixed(2).replace('-', '')
            };
            paypalOptions['lineItems'].push(correction);
          }  
        }
        if (estimate && paypalOptions['lineItems']) {
          paypalOptions['lineItems'].push(estimate);
        }
        console.log('[GH] braintree paypal options', paypalOptions);
        //this.emitCustomEvent('PayPalButtonClick', 'BrainTree');
        return this.paypalCheckoutInstance.createPayment(paypalOptions);
      },

      onShippingChange: async (data:any, actions:any) => {
/*         this.isSelectedCB2 = true;
 */        return this.actionHandler(data, actions).then((ret) => {
          console.log('[GH] braintree paypal shipping change response: ' + ret, data);
          if (!ret) return actions.reject();
          return actions.resolve();
        });
      },

      onApprove: (data:any, actions:any) => {
       // this.braintreeCustomLoadingMessage();
/*         this.isSelectedCB2 = true;
 */        console.log('[GH] braintree paypal approve', data);
        this.braintreeTokenizePaymentData = data;
        if (typeof data.paymentID == 'string') this.paypalpaymentId = data.paymentID;
        console.log('[GH] braintree paypal approve actions', actions);
        //this.braintreeTokenizePayment();
        this.braintreeGetNonce();
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        
        //this.emitCustomEvent('PayPalApproved', 'Braintree');
      },

      onCancel: (data:any) => {
        console.log('[GH] handle cancel');
        (window as any)['facebookAutofillDisabled']=false;
        console.log('PayPal payment cancelled', JSON.stringify(data));
        console.log('PayPal payment cancelled for guest', this.orderDetailsInfo.order.guest);
        if((<HTMLDivElement> document.querySelector('#dropin-container'))) {
          (<HTMLDivElement> document.querySelector('#dropin-container')).style.display = 'block'; 
        }
       // this.emitCustomEvent('PayPalCancelled', 'BrainTree')  ;
        this.braintreePayPalTokenizedPayment = null; 
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        this.toastCtrl.create({
          message: `Please choose an option to continue`,
          position: 'top',
          duration: 3000
        });
      },

      onError: (err:any) => {
        console.log('todo handle error')
        console.error('PayPal error', err);
        this.spinner.disable();
       // this.emitCustomEvent('PayPalError', 'BrainTree');
        // close the new overlay
        if (document.body.contains(this.overlayDiv)) {
          document.body.removeChild(this.overlayDiv);
        }
        // show toast message 
        this.toastCtrl.create({
          message: `Please choose an option to continue`,
          position: 'top',
          duration: 3000
        });
      }
    }).render('#paypal-button').then(() => {
      (<HTMLDivElement>document.querySelector('#paypal-button')).style.display = 'flex';
    });
  }


  /**
   * Creates a transaction record in the system for a Braintree payment
   * 
   * @param upsell - The upsell order details
   * @param response - The response from Braintree containing transaction details
   * @param captureId - The capture ID for the transaction
   * @returns Promise that resolves when transaction is created successfully
   */
  createTransactionBraintree(upsell:any, response:any, captureId:any) {
    console.log('[GH] createTransactionBraintree upsell', upsell);
    console.log('[GH] createTransactionBraintree response', response);
    console.log('[GH] createTransactionBraintree orderId', upsell.id);
    console.log('[GH] createTransactionBraintree ' + this.braintreeCurrencyConversion);
    return new Promise((resolve, reject) => {
      let braintreeinterval = setInterval(async () => {
        clearInterval(braintreeinterval);
        this.tcrApiOrder.createTransaction({
          orderId: upsell.id, status: response.success ? 'Approved' : 'Failed',
          method: 'Braintree ' + response.transaction.currencyIsoCode ? response.transaction.currencyIsoCode : '', message: response.transaction.creditCard.maskedNumber.replace('null******null', 'PayPal') +
            ' token ' + response.transaction.creditCard.token + ' '
            + response.transaction.status + ' ' + response.transaction.currencyIsoCode ? response.transaction.currencyIsoCode : '' + ' currencyConversion ' + this.braintreeCurrencyConversion +
            ' ' + this.currencySymbol + (response.transaction.amount),
          original: JSON.stringify(response.transaction)
        })
          .subscribe((result:any) => {
            if (result.message === 'The transaction has been created') {
              resolve({ message: 'success' });
            } else {
              reject('Transaction was not created!');
            }
          }, (error:any) => {
            reject(error);
          });
      }, 300);
    });
  }

  /**
   * Processes the result from a Braintree transaction
   * 
   * This method handles the response after a Braintree payment is processed.
   * It will:
   * - Store the PayPal payment token if available
   * - Handle force upsell declined
   * - Create a transaction record
   * - Update purchased upsells state
   * - Handle transaction fees if applicable
   * - Navigate to the next page in the funnel
   *
   * @param result - The result object from Braintree containing transaction details
   */

  /**
   * Processes the result from a Braintree transaction
   * 
   * This method handles the response after a Braintree payment is processed.
   * It will:
   * - Store the PayPal payment token if available
   * - Handle force upsell declined
   * - Create a transaction record
   * - Update purchased upsells state
   * - Handle transaction fees if applicable
   * - Navigate to the next page in the funnel
   *
   * @param result - The result object from Braintree containing transaction details
   */

  async processBraintreeResult(result:any) { // TOUC-14710 - Braintree
    console.log('[GH] processBraintreeResult result', result);
    this.spinner.enable('Please wait...');

    if(typeof result.result.transaction.paypalAccount !== 'undefined') {
      let token = result.result.transaction.paypalAccount.implicitlyVaultedPaymentMethodToken; 
      if(token) {
        sessionStorage.setItem('braintree-payment-token', token);
        console.log('[GH] braintree-payment-token', token);
      }
    }
   


    if (document.location.search.indexOf('braintreeforceupselldeclined=true') > -1) {
      console.log('[GH] braintreeforceupselldeclined=true');
      result.result.success = false;
    }

    if (result.result.success) {
      await this.createTransactionBraintree(result.upsell, result.result, 'Approved');
      setTimeout(async () => {
      await this.stateProvider.setPurchasedUpsells(result.upsell);

      if (this.paymentMethod.standard && this.transactionFeeAmount > 0) {
        this.captureTransactionFee(result.orderId);
        this.orderSTxId = '';
      }
      this.purchasedUpsells.push(result.upsell.order);
      const params: any = await this.funnelProvider.getNextPage(undefined, true);
      if (!params) {
        this.spinner.disable();
        return this.toastCtrl
          .create({
            message: `Page not found`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          })
          //.present();
      }
      const { component, orderForm, type } = params;
      if (type === 'Upsell' || type === 'Downsell') {
        await this.stateProvider.setUpsells([orderForm]);
      }
      this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
        .then(() => {
          this.spinner.disable();
        })
        .catch((error) => {
          this.toastCtrl.create({
            message: `Couldn't navigate to the next page`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          });
          console.log('Error on upgradeOrder()', error);
          this.spinner.disable();
        });
      }, 1000);
      
    } else {
      this.toastCtrl
      .create({
        message: `Error with upgrading order!  Please contact customer support.`,
        position: 'top',
      })
      //.present();
      this.createTransactionBraintree(result.upsell, result.result, 'Failed');
      const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
      if (!params) {
        this.spinner.disable();
        return this.toastCtrl
          .create({
            message: `Page not found`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          })
          //.present();
      }
      const { component } = params;
      this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
        .then(() => {
          this.spinner.disable();
        })
        .catch((error) => {
          this.toastCtrl.create({
            message: `Couldn't navigate to the next page`,
            position: 'top',
            showCloseButton: true,
            cssClass: 'errorToast',
          });
          console.log('Error on upgradeOrder()', error);
          this.spinner.disable();
        });
    }
 
  }

  /**
   * Upgrades the order with the selected payment method
   * 
   * This method handles the upgrade process for different payment methods.
   * It will:
   * - Handle PayPal payments
   * - Handle Braintree payments with existing payment token
   * - Handle Braintree payments with new payment token
   * - Handle Braintree payments with no payment token
   * - Handle Braintree payments with no payment method
   * - Handle Braintree payments with no payment method
   * 
   * @param upsells - The upsell order details
   * @param dataForTax - The data for tax
   * @param totalTax - The total tax
   * @returns Promise that resolves when the order is upgraded
   */ 
  upgradeOrder() {
    this.spinner.enable('Updating order.<br>Please Wait');
    let upsells = [{ sfid: this.upsell.sfid, count: 1 }];
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let totalTax = this.taxRate.totalTax || 0;

    if (this.paymentMethod.paypal) {
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.upgradePayPalOrder();
    } else if (this.paymentMethod.braintreeMethod && sessionStorage.getItem('braintree-payment-token') && sessionStorage.getItem('braintree-payment-token') != 'null') {
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.upgradeBraintreeOrder(sessionStorage.getItem('deviceData'));  // TOUC-14710  -  Braintree GBP
    } else if (this.paymentMethod.braintreeMethod) {
      const braintreeToken = sessionStorage.getItem('braintree-payment-token');
      if (!braintreeToken || braintreeToken === 'null') {
        this.spinner.disable();
        // Show PayPal button dialog instead of alert
        this.showPayPalButtonDialog();

        // Add PayPal button styles
        const styles = {
          layout: 'vertical',
          color: 'gold',
          shape: 'rect',
          label: 'paypal'
        };

        this.setupBraintreeClient().then(() => {
          console.log('[GH] braintree client setup complete');


        }).catch((e) => {
          console.log('[GH] braintree client setup exception ', e);
          this.tearDownBraintree();
        });
        const rate = this.braintreeCurrencyConversion = parseFloat(this.orderDetailsInfo.order.crv);
        console.log('[GH] braintree currency conversion rate', rate);



      }
    } else {
      // Previously we vaulted all transactions per Braintree's recommendation, but now we only vault subscription payments
      this.toastCtrl.create({ message: `Updating order...`, duration: 3000, position: 'top' })//.present();
      this.order.transactionFeeAmount = this.transactionFeeAmount;
      this.order.transactionFeeDocumentId = this.orderSTxId;
      this.tcrApiOrder
        .payUpsells(this.order, upsells, this.upsell.type, totalTax, dataForTax)
        .toPromise()
        .then(
          async (result:any) => {
            let stp = this.urlsHelper.getParameterFromUrl({url: document.location.search, parameter: 'step'})
            this.spinner.enable('Please wait...');
            if (result.message === 'success') {
              if (this.paymentMethod.standard && this.transactionFeeAmount > 0) {
                this.captureTransactionFee(result.orderId);
                this.orderSTxId = '';
              }
              this.purchasedUpsells.push(result.order);
              await this.stateProvider.setPurchasedUpsells(result.order);
              const params: any = await this.funnelProvider.getNextPage(undefined, true);
              if (!params) {
                this.spinner.disable();

                if( typeof (window as any)['funnelConfsForUUID'] == 'object') {
                  // handle the configuration error
                  let brokenfunnel = (window as any)['funnelConfsForUUID'];
                  let brokenfunnel_firstUpsell = brokenfunnel.defaultFunnels[stp].variants[0].url;
                  let alt = this.getAlternativeOffer(brokenfunnel_firstUpsell);
                  if(alt) {
                    console.log("redirecting to alternative offer: " + alt);
                    //return this.navCtrl.setRootExt(alt, { name: alt},{currentStep: stp, nextStep: (stp+1) });
                    //return this.navCtrl.setRootExt(alt, { name: alt});
                    return this.navCtrl.setRootExt(alt, { name: alt, isUpsell: true }, { taken: true, alternate: true})

                  }
                }
                
                return this.toastCtrl
                  .create({
                    message: `Page not found`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  })
                 // .present();
              }
              const { component, orderForm, type } = params;
              if (type === 'Upsell' || type === 'Downsell') {
                await this.stateProvider.setUpsells([orderForm]);
              }
              this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
                .then(() => {
                  this.spinner.disable();
                })
                .catch((error) => {
                  this.toastCtrl.create({
                    message: `Couldn't navigate to the next page`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  });
                  console.log('Error on upgradeOrder()', error);
                  this.spinner.disable();
                });
            } else {
              const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
              if (!params) {
                this.spinner.disable();
                return this.toastCtrl
                  .create({
                    message: `Page not found`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  })
                 // .present();
              }
              const { component } = params;
              this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
                .then(() => {
                  this.spinner.disable();
                })
                .catch((error) => {
                  this.toastCtrl.create({
                    message: `Couldn't navigate to the next page`,
                    position: 'top',
                    showCloseButton: true,
                    cssClass: 'errorToast',
                  });
                  console.log('Error on upgradeOrder()', error);
                  this.spinner.disable();
                });
            }
            return;
          },
          async (error:any) => {
            console.log('Error on upsell purchase!', error);
            this.spinner.disable();
            const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
            if (!params) {
              this.spinner.disable();
              return this.toastCtrl
                .create({
                  message: `Page not found`,
                  position: 'top',
                  showCloseButton: true,
                  cssClass: 'errorToast',
                })
               // .present();
            }
            const { component } = params;
            this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
              .then(() => {
                this.spinner.disable();
              })
              .catch((error) => {
                this.toastCtrl.create({
                  message: `Couldn't navigate to the next page`,
                  position: 'top',
                  showCloseButton: true,
                  cssClass: 'errorToast',
                });
                console.log('Error on upgradeOrder()', error);
                this.spinner.disable();
              });
          },
        );

    }
}


  /**
   * Upgrades the order with PayPal payment
   * 
   * This method handles the upgrade process for PayPal payments.
   * It will:
   * - Create a payment order 
   * - Navigate to the next page in the funnel
   * 
   * @returns Promise that resolves when the order is upgraded
   */
  upgradePayPalOrder() {
    this.spinner.enable('Executing order.<br> Please Wait');
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let paymentData = {
      totalPrice: +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2),
      accDetails: this.orderDetailsInfo.navParams.accDetails,
      orderType: this.upsell.type,
      OffersData: [],
      bumpOffers: [],
      parentOrder: this.orderDetailsInfo.navParams.order,
      totalTax: this.taxRate.totalTax || 0,
      dataForTax: dataForTax,
      countries: this.countries
    };
    (paymentData.OffersData as any).push(this.upsell);
    this.paypalPayment.createPaymentUpsell(paymentData).then(
      (result: any) => {
        this.purchasedUpsells.push(result.order);
        this.stateProvider
          .setOrderDetails({
            order: this.orderDetailsInfo.navParams.order,
            upsells: this.orderDetailsInfo.navParams.upsells,
            purchasedUpsells: this.purchasedUpsells,
            upsellIndex: this.upsellIndex,
            paymentMethod: 'PayPal',
          })
          .then((state) => {
            this.state = state;
            this.plannedLeavePage = true;
            console.log('[GH] saving PayPalNVPParameters',document.location.search)
            sessionStorage.setItem('PayPalNVPParameters', document.location.search);
            window.open(result.url, '_self', 'location=no');
          });
      },
      () => {
        this.toastCtrl
          .create({
            message: `Error with upgrading paypal order!`,
            duration: 3000,
            position: 'top',
          })
          //.present();
        this.spinner.disable();
      },
    );
  }

  /**
   * Upgrades the order with Braintree payment
   * 
   * This method handles the upgrade process for Braintree payments.
   * It will:
   * - Create a payment order
   * - Navigate to the next page in the funnel
   * 
   * @param deviceData - The device data
   * @returns Promise that resolves when the order is upgraded
   */
  upgradeBraintreeOrder(deviceData:any) {
    this.spinner.enable('Executing order.<br> Please Wait');
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(
      this.dataForTax,
      this.upsell,
    );
    let paymentData = {
      totalPrice: +(this.upsell.offerPrice + this.upsell.shippingCost).toFixed(2),
      accDetails: this.orderDetailsInfo.navParams.accDetails,
      orderType: this.upsell.type,
      OffersData: [],
      bumpOffers: [],
      parentOrder: this.orderDetailsInfo.navParams.order,
      totalTax: this.taxRate.totalTax || 0,
      dataForTax: dataForTax,
      countries: this.countries,
      paymentMethod: this.orderDetailsInfo.navParams.paymentMethod,     
      namedAgent: 'Braintree'
    };
    (paymentData.OffersData as any).push(this.upsell);
    // TODO - this creates the order by not a payment profile yet for guest user MVP version
    this.paypalPayment.createOrderBraintreeUpsell(paymentData).then(
      (result: any) => {
        console.log('before order', this.order);
        console.log('before this.upsell', this.upsell);
        console.log('before result', result);
        this.purchasedUpsells.push(result.order);
        this.stateProvider
          .setOrderDetails({
            order: this.orderDetailsInfo.navParams.order,
            upsells: this.orderDetailsInfo.navParams.upsells,
            purchasedUpsells: this.purchasedUpsells,
            upsellIndex: this.upsellIndex,
            paymentMethod: this.orderDetailsInfo.navParams.paymentMethod
          })
          .then((state) => {
            this.state = state;
            let braintreeClientToken = sessionStorage.getItem('braintree-payment-token');
            console.log('after order', this.order);
            console.log('after this.upsell', this.upsell);
            console.log('after result', result);
            const countryISO = this.calculateHelper.getCountryISOCode(this.countries, this.order.billCountry);
            let braintreeCurrencyConversion = this.order.crv || '1';
            let description = result.order.name + ' currencyConversion ' + this.braintreeCurrencyConversion + ' Total: $' + (result.order.total) + '  Tax: $' + result.order.tax; 
            console.log('orderDetailsInfo', this.orderDetailsInfo);
            let body: any = {
              "orderTotal": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "totalPrice": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "totalTax": +(result.order.tax * parseFloat(braintreeCurrencyConversion)).toFixed(2),
              "braintreeCurrencyConversion": braintreeCurrencyConversion,
              "submitForSettlement": true,
              "accDetails": {
                "email": this.order.customerEmail,
                "billingAddress": {
                  "country": result.order.billingCountry,
                  "state": result.order.billingState,
                  "city": result.order.billingCity,
                  "street": result.order.billingAddress,
                  "postal": result.order.billingZip,
                  "st": result.order.billingState
                },
              },
              "billingCountryAlpha2": countryISO,
              "amount": +(result.order.total * parseFloat(braintreeCurrencyConversion)).toFixed(2).toString(),
              "currency": sessionStorage.getItem('officialCurrency'),
              "deviceData": deviceData,
              "description": description
            }
            if(braintreeClientToken && braintreeClientToken != "null" && braintreeClientToken != "undefined") {
              // durable token found
              body['paymentMethodToken'] = braintreeClientToken;
            } else {
              // no token, need a new nonce
              body['nonce'] = this.braintreeNonce;
              body['authorize'] = false;
              body['currency'] = sessionStorage.getItem('officialCurrency') || 'USD';
              body['orderId'] = result.order.id;
              body['amount'] = result.order.total;
              body['deviceData'] = deviceData;
              body['subTotalAmount'] = result.order.total.toString();
              body['taxAmount'] = result.order.tax.toString();
              body['shippingAmount'] = "0.00"; //TODO - add shipping amount
              body['discountAmount'] = "0.00"; //TODO - add discount amount
              body['options'] = {
                "submitForSettlement": true,
                "storeInVaultOnSuccess": true
              };
              body['custom_fields'] = {
                "merchant_order_details": description
              };
              body['customer'] = {
                "email": result.order.customerEmail,
                "firstName": result.order.billFirstName,
                "lastName": result.order.billLastName,
              };
              body['billing'] = {
                "firstName": result.order.billFirstName,
                "lastName": result.order.billLastName,
                "streetAddress": result.order.billingAddress,
                "extendedAddress": result.order.billingAddress2,
                "locality": result.order.billingCity,
                "region": result.order.billingState,
                "postalCode": result.order.billingZip,
                "countryName": result.order.billingCountry
              };
              body['shipping'] = {
                "firstName": result.order.shipFirstName,
                "lastName": result.order.shipLastName,
                "streetAddress": result.order.shipAddress,
                "extendedAddress": result.order.shipAddress2,
                "locality": result.order.shipCity,
                "region": result.order.shipState,
                "postalCode": result.order.shipZip,
                "countryName": result.order.shipCountry
              };
   
              body['braintreeMethod'] = 'paypal_checkout_vault';
              body['paymentMethodNonce'] = this.braintreeNonce;
              body['authorize'] = false;
            

            }
            let xhr = new XMLHttpRequest();
            let asy = false;
            xhr.open('POST', '/checkout-braintree/', asy);
            xhr.withCredentials = true;
            if (typeof (window as any)['getCookie'] === 'function') xhr.setRequestHeader('XSRF-TOKEN', (window as any)['getCookie']('XSRF-TOKEN')); // [TOUC-5682]
            xhr.onload = (e) => {
              if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                  console.log('[GH] braintree response', JSON.parse(xhr.responseText));
                  let ret = JSON.parse(xhr.responseText);
                  ret['order'] = this.order;
                  ret['upsell'] = result.order;
                  this.processBraintreeResult(ret);
                  return xhr.responseText;
                } else {
                  console.error('[GH] Braintree error ', xhr.statusText);
                  this.spinner.disable();
                  this.toastCtrl
                    .create({
                      message: `Error with upgrading braintree order.`,
                      position: 'top',
                      showCloseButton: true,
                      cssClass: 'errorToast',
                    })
                    //.present();
                  this.navCtrl.setRootExt('OrderSuccessCommonPage', {
                    name: 'Order Success', isUpsell: true
                  });
                  return { error: true, message: xhr.statusText };
                }
              }
              return;
            };
            xhr.onerror = (e) => {
              console.error(xhr.statusText);
            };

            (xhr as any)['dataType'] = 'json';
            xhr.setRequestHeader('X-Brand', (window as any)['process_env'].BRAND);
            xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            console.log('[GH] braintree request body', body);
            xhr.send(JSON.stringify(body));
          

          });
      },
      () => {
        this.toastCtrl
          .create({
            message: `Error with upgrading braintree paypal order!`,
            duration: 3000,
            position: 'top',
          })
         // .present();
        this.spinner.disable();
      },
    );
  }

  executePayPalPayment(paramData:any) {
    this.spinner.enable('Executing order.<br> Please Wait');
    paramData['isUpsell'] = true;
    paramData.dataForTax = this.state.taxData;
    this.paypalPayment.executePayment(paramData)
      .then(async (res: any) => {
        this.spinner.enable('Loading page <br> Please wait...');
        if (res.message === 'success') {
          await this.stateProvider.setPurchasedUpsells(res.orderDetails.purchasedUpsells[res.orderDetails.purchasedUpsells.length - 1]);
          const params: any = await this.funnelProvider.getNextPage(undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
              //.present();
          }
          const { component, orderForm, type } = params;
          if (type === 'Upsell' || type === 'Downsell') {
            await this.stateProvider.setUpsells([orderForm]);
          }
          this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
        } else {
          const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
            //  .present();
          }
          const { component } = params;
          this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
        }
      },
        async (error) => {
          console.log('Error on upsell purchase!', error);
          this.spinner.enable('Loading page <br> Please wait...');
          const params = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
            //  .present();
          }
          const { component } = params;
          this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on executePayPalPayment()', error);
              this.spinner.disable();
            });
        },
      );
  }

  executePayPalNVP(urlParameters:any, upsellOrder:any) {
    this.urlsHelper.clearPayPalParams();
    this.spinner.enable('Executing order.<br> Please Wait');
    const upsellOrderDetails = {
      order: upsellOrder,
      isUpsell: true};
    const shippingFullCountry = upsellOrderDetails.order.shippingCountry;
    const countryISO = this.calculateHelper.getCountryISOCode(this.countries, shippingFullCountry);
    const stateISO = this.countries && this.countries[shippingFullCountry] && this.countries[shippingFullCountry].states ?
      Object.keys(this.countries[shippingFullCountry].states).find(e => this.countries[shippingFullCountry].states[e] === upsellOrderDetails.order.shippingState)
      : upsellOrderDetails.order.shippingState;
    let executeBody = {
      order: upsellOrderDetails,
      paymentBody: {
        TOKEN: urlParameters.token,
        PAYERID: urlParameters.PayerID,
        PAYMENTREQUEST_0_AMT: +upsellOrderDetails.order.total.toFixed(2),
        PAYMENTREQUEST_0_CURRENCYCODE: 'USD',
        PAYMENTREQUEST_0_SHIPTONAME: upsellOrderDetails.order.customerName,
        PAYMENTREQUEST_0_SHIPTOSTREET: upsellOrderDetails.order.shippingAddress,
        PAYMENTREQUEST_0_SHIPTOCITY: upsellOrderDetails.order.shippingCity,
        PAYMENTREQUEST_0_SHIPTOSTATE: stateISO,
        PAYMENTREQUEST_0_SHIPTOZIP: upsellOrderDetails.order.shippingZipPostal,
        PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE: countryISO,
        L_PAYMENTREQUEST_0_AMT0: +upsellOrderDetails.order.orderItems[0].totalPrice,
        L_PAYMENTREQUEST_0_NAME0: upsellOrderDetails.order.orderItems[0].productName,
        L_PAYMENTREQUEST_0_QTY0: upsellOrderDetails.order.orderItems[0].quantity,
        PAYMENTREQUEST_0_ITEMAMT: +upsellOrderDetails.order.orderItems[0].productPrice.toFixed(2),
        PAYMENTREQUEST_0_SHIPPINGAMT: +upsellOrderDetails.order.orderShippingCost.toFixed(2),
        PAYMENTREQUEST_0_TAXAMT: +upsellOrderDetails.order.tax.toFixed(2),
      }
    };
    if (this.taxServiceEnabled) {
      (executeBody as any)['dataForTax'] = this.state.taxData;
    }

    this.tcrApiOrder.doExpressCheckout(executeBody)
      .subscribe(async (response:any) => {
        this.spinner.enable('Loading page <br> Please wait...');
        await this.stateProvider.setPurchasedUpsells(response.order);
        const params: any = await this.funnelProvider.getNextPage(undefined, true);
        if (!params) {
          this.spinner.disable();
          return this.toastCtrl
            .create({
              message: `Page not found`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            })
           // .present();
        }
        const { component, orderForm, type } = params;
        if (type === 'Upsell' || type === 'Downsell') {
          await this.stateProvider.setUpsells([orderForm]);
        }
        this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
          .then(() => {
            this.spinner.disable();
          })
          .catch((error) => {
            this.toastCtrl.create({
              message: `Couldn't navigate to the next page`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            });
            console.log('Error on executePayPalNVP()', error);
            this.spinner.disable();
          });
      }, async (error) => {
        this.spinner.disable();
        const params = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
        if (!params) {
          this.spinner.disable();
          return this.toastCtrl
            .create({
              message: `Page not found`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            })
           // .present();
        }
        const { component } = params;
        this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
          .then(() => {
            this.spinner.disable();
          })
          .catch((error) => {
            this.toastCtrl.create({
              message: `Couldn't navigate to the next page`,
              position: 'top',
              showCloseButton: true,
              cssClass: 'errorToast',
            });
            console.log('Error on executePayPalNVP()', error);
            this.spinner.disable();
          });
      });
  }


  override getTaxRateForUpsells(data:any) {
    // generate data for get tax amount for upsels
    let dataForTax: any = {};
    let shipCountry = data.detailsInfo.order.shippingCountry;
    let shipState = data.detailsInfo.order.shippingState;

    if (data.upsellIndex < 0) {
      data.upsellIndex = 0;
    }

    if (this.countries && this.countries[shipCountry] && this.countries[shipCountry].states) {
      for (let state in this.countries[shipCountry].states) {
        this.statesList.push({ value: state, label: this.countries[shipCountry].states[state] });
      }
    }

    let to_state = '';
    for (let i = 0; i < this.statesList.length; i++) {
      if (this.statesList[i].label === shipState) {
        to_state = this.statesList[i].value;
      }
    }

    let accountDetails = {
      shipTo: {
        line1: data.detailsInfo.order.shippingAddress,
        city: data.detailsInfo.order.shippingCity,
        region: to_state || shipState,
        country: this.countries[shipCountry] ? this.countries[shipCountry].value : shipCountry,
        postalCode: data.detailsInfo.order.shippingZipPostal,
      },
    };

    dataForTax['accountDetails'] = accountDetails;
    let productDetails = [];
    let item = {};
    item = {
      number: data.detailsInfo.upsells[data.upsellIndex].sfid,
      quantity: 1,
      amount: data.detailsInfo.upsells[data.upsellIndex].offerPrice,
      taxCode: data.detailsInfo.upsells[data.upsellIndex].productTaxCode,
      description: data.detailsInfo.upsells[data.upsellIndex].name,
      productDescription: data.detailsInfo.upsells[data.upsellIndex].productDescription,
    };
    productDetails.push(item);
    dataForTax.productDetails = productDetails;
    dataForTax.shipping = data.detailsInfo.upsells[data.upsellIndex].shippingCost;
    dataForTax.total = data.detailsInfo.upsells[data.upsellIndex].offerPrice;
    return dataForTax;
  }

  payWithAmazon() {
    this.spinner.enable('Executing order.<br> Please Wait');
    let dataForTax = this.tcrApiRemoteServices.getDataForTaxUpgradeOrder(this.dataForTax, this.upsell);
    let upsells = [{ sfid: this.upsell.sfid, count: 1 }];
    let body:any = {
      accId: this.order.accountId,
      orderType: this.upsell.type,
      parent: this.order.id,
      orderSource: 'Funnel',
      customerIp: sessionStorage.getItem('ip'),
      upsells: upsells,
      orderTotal: +(this.upsell.offerPrice + this.upsell.shippingCost + (this.taxRate.totalTax || 0)).toFixed(2),
      totalTax: this.taxRate.totalTax || 0,
      dataForTax: dataForTax,
    };

    body['paymentMethod'] = 'Amazon Pay';
    body['namedAgent'] = 'Amazon Pay';
    body['brand'] = (window as any)["process_env"].BRAND;
    body['orderReferenceId'] = (<any>window).orderReferenceId;
    body['AccessToken'] = (<any>window).access_token;

    this.plannedLeavePage = true;

    this.tcrApiOrder.captureAmazon(body).toPromise()
      .then(
        async (result:any) => {
          for (let index = 0; index < this.buttonList.length; index++){
            this.buttonList[index].isPlaceOrder = true;
          }
          this.spinner.enable('Please wait...');

          this.purchasedUpsells.push(result.order);
          await this.stateProvider.setPurchasedUpsells(result.order);
          const params: any = await this.funnelProvider.getNextPage(undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
            //  .present();
          }
          const { component, orderForm, type } = params;
          if (type === 'Upsell' || type === 'Downsell') {
            await this.stateProvider.setUpsells([orderForm]);
          }
          this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on upgradeOrder()', error);
              this.spinner.disable();
            });
        },
        async (error) => {
          for (let index = 0; index < this.buttonList.length; index++){
            this.buttonList[index].isPlaceOrder = true;
          }
          console.log('Error on upsell purchase!', error);
          this.spinner.disable();
          const params: any = await this.funnelProvider.getNextPage(undefined, undefined, undefined, true);
          if (!params) {
            this.spinner.disable();
            return this.toastCtrl
              .create({
                message: `Page not found`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              })
             // .present();
          }
          const { component } = params;
          this.navCtrl.setRootExt(component.name, { name: component.name, isUpsell: true }, { taken: true})
            .then(() => {
              this.spinner.disable();
            })
            .catch((error) => {
              this.toastCtrl.create({
                message: `Couldn't navigate to the next page`,
                position: 'top',
                showCloseButton: true,
                cssClass: 'errorToast',
              });
              console.log('Error on upgradeOrder()', error);
              this.spinner.disable();
            });
        },
      );
  }

}
